import { createTheme } from '@material-ui/core/styles';

// Tailwind default color palette
const cloudCFOColors = {
  primary: {
    main: '#2563eb', // blue-600
    light: '#3b82f6', // blue-500
    dark: '#1d4ed8', // blue-700
    contrastText: '#fff',
  },
  secondary: {
    main: '#f59e42', // orange-400
    light: '#fbbf24', // orange-300
    dark: '#ea580c', // orange-600
    contrastText: '#fff',
  },
  error: {
    main: '#ef4444', // red-500
    contrastText: '#fff',
  },
  warning: {
    main: '#f59e42', // orange-400
    contrastText: '#fff',
  },
  info: {
    main: '#0ea5e9', // sky-500
    contrastText: '#fff',
  },
  success: {
    main: '#22c55e', // green-500
    contrastText: '#fff',
  },
  grey: {
    50: '#f9fafb',
    100: '#f3f4f6',
    200: '#e5e7eb',
    300: '#d1d5db',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#374151',
    800: '#1f2937',
    900: '#111827',
  },
};

const theme = createTheme({
  typography: {
    fontFamily: '"Brandon Text", "Arial", "Helvetica Neue", Arial, sans-serif',
    fontSize: 16,
    h1: {
      fontSize: '2.25rem', // text-4xl
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '1.875rem', // text-3xl
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h3: {
      fontSize: '1.5rem', // text-2xl
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h4: {
      fontSize: '1.25rem', // text-xl
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h5: {
      fontSize: '1.125rem', // text-lg
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h6: {
      fontSize: '1rem', // text-base
      fontWeight: 700,
      lineHeight: 1.2,
    },
    body1: {
      fontSize: '1rem', // text-base
      fontWeight: 400,
      lineHeight: 1.5,
    },
    body2: {
      fontSize: '0.875rem', // text-sm
      fontWeight: 400,
      lineHeight: 1.5,
    },
    caption: {
      fontSize: '0.75rem', // text-xs
      fontWeight: 400,
      lineHeight: 1.4,
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  palette: {
    primary: cloudCFOColors.primary,
    secondary: cloudCFOColors.secondary,
    error: cloudCFOColors.error,
    warning: cloudCFOColors.warning,
    info: cloudCFOColors.info,
    success: cloudCFOColors.success,
    grey: cloudCFOColors.grey,
    background: {
      default: cloudCFOColors.grey[50],
      paper: '#fff',
    },
    text: {
      primary: cloudCFOColors.grey[900],
      secondary: cloudCFOColors.grey[600],
      disabled: cloudCFOColors.grey[400],
    },
  },
  shape: {
    borderRadius: 8, // rounded-md
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          fontFamily:
            '"Brandon Text", "Arial", "Helvetica Neue", Arial, sans-serif',
        },
        '*': {
          fontFamily:
            '"Brandon Text", "Arial", "Helvetica Neue", Arial, sans-serif',
        },
      },
    },
  },
});

export default theme;
